<div class="d-flex h-100-p justify-content-center align-items-center">
  <kendo-loader [type]="'infinite-spinner'"></kendo-loader>
</div>
